const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  permission: state => state.user.permission,
  menuList: state => state.user.menuList,
  isAdmin: state => state.user.isAdmin,
  dateTimeFormate: state => state.user.dateTimeFormate,
  defaultTimeZone: state => state.user.defaultTimeZone,
  googleMapApiKey: state => state.user.googleMapApiKey,
  companyLocation: state => state.user.companyLocation,
  companyLogo: state => state.system.companyLogo,
  isQBActive: state => state.user.isQBActive,
  isAweberActive: state => state.user.isAweberActive,
  displayCityInschedule: state => state.user.displayCityInschedule,
  displayZipInschedule: state => state.user.displayZipInschedule,
  showLoader: state => state.system.showLoader,
  loaderMessage: state => state.system.loaderMessage,
  showAlert: state => state.system.showAlert,
  alertMessage: state => state.system.alertMessage,
  alertColor: state => state.system.alertColor,
  fullScreenDialogForJob: state => state.system.fullScreenDialogForJob,
  jobId: state => state.system.jobId,
  isEdit: state => state.system.isEdit,
  fullScreenDialogForInvoice: state => state.system.fullScreenDialogForInvoice,
  invoiceId: state => state.system.invoiceId,
  fullScreenDialogForPayment: state => state.system.fullScreenDialogForPayment,
  paymentRecordId: state => state.system.paymentRecordId,
  globalEmailDialog: state => state.system.globalEmailDialog,
  emailTemplateId: state => state.system.emailTemplateId,
  systemTopBarColor: state => state.system.systemTopBarColor,
  globalFullScreenEmail: state => state.system.globalFullScreenEmail,
  communicationId: state => state.system.communicationId,
  globalFileManager: state => state.system.globalFileManager,
  globalFileManagerForCustomer: state => state.system.globalFileManagerForCustomer,
  fileManagerRequestResource: state => state.system.fileManagerRequestResource,
  globalAddressLayout: state => state.system.globalAddressLayout,
  addressDetail: state => state.system.addressDetail,
  companyDetail: state => state.system.companyDetail,
  fullScreenAdvanceSearch: state => state.system.fullScreenAdvanceSearch,
  advanceSearchValue: state => state.system.advanceSearchValue,
  globalNearMeCustomers: state => state.system.globalNearMeCustomers,
  leadid: state => state.system.leadid,
  addressid: state => state.system.addressid,
  distanceUnit: state => state.user.distanceUnit,
  fullScreenDialogForQB: state => state.system.fullScreenDialogForQB,
  crmCompanyId: state => state.system.crmCompanyId,
  companyId: state => state.system.companyId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js